// ProtectedRoute.jsx
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useUser } from "../../context/UserContext";

/**
 * ProtectedRoute - A wrapper component that guards protected routes
 * 
 * @param {string[]} allowedRoles - Array of role_keys that can access the route (empty = any authenticated user)
 * @param {string} redirectTo - Where to redirect unauthenticated users (default: /login)
 */
const ProtectedRoute = ({
    allowedRoles = [],
    redirectTo = "/login"
}) => {
    const { user, loading } = useUser();
    const location = useLocation();

    // Show loading state while checking authentication
    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                fontSize: '16px'
            }}>
                <div className="loading">
  <span>Loading...</span>
</div>
            </div>
        );
    }

    // Not authenticated - redirect to login
    if (!user) {
        // Save the attempted URL so we can redirect back after login
        return <Navigate to={redirectTo} state={{ from: location }} replace />;
    }

    // Check role if specific roles are required
    if (allowedRoles.length > 0 && !allowedRoles.includes(user.role_key)) {
        // User doesn't have the required role - redirect to home or unauthorized page
        return <Navigate to="/unauthorized" replace />;
    }

    // User is authenticated and authorized - render the route
    return <Outlet />;
};

export default ProtectedRoute;
